import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getBrands = (params) => httpClient.get(`${ENDPOINT_API.BRANDS}`, { params });

export {
	getBrands,
};
